import { render, staticRenderFns } from "./accordion-list.vue?vue&type=template&id=6697847a"
import script from "./accordion-list.vue?vue&type=script&lang=ts"
export * from "./accordion-list.vue?vue&type=script&lang=ts"
import style0 from "./accordion-list.vue?vue&type=style&index=0&id=6697847a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports